import React from "react";

const Admin: React.FC = () => {
  return (
    <p>Admin Page</p>
  )
}

export default Admin;
